import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { LabService } from 'src/app/services/lab.service';
import { PharmacyService } from 'src/app/services/pharmacy.service';
import * as $ from 'jquery'
import { FireBaseMessagingService } from 'src/app/services/fire_base-messaging/fire-base-messaging.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  showotp: boolean = false;
  showotp_user: boolean = false;
  showotp_user_login: boolean = false
  showpass: boolean = false
  showpass_user: boolean = false
  loginhide: boolean = false
  @Input('partner') partner: boolean
  phoneNo: string = ''
  phoneNo_user: string
  countryCode_user: string = '+91'
  countryCode: string = '+91'
  checkOtp: any
  checkOtp_user: any = {
    data: '',
    otp: 0
  }
  errorOtp: boolean = false
  errorOtpMessage: string = ''
  errorOtpUserMessage: string = ''
  errorOtp_user: boolean = false
  errorPass: boolean = false
  verifyOtpError: boolean = false
  verifyPassError: boolean = false
  verifyPassError_user: boolean = false
  verifyOtpError_user: boolean = false
  isLoggedin: boolean = false

  otpValObjUser1: String
  otpValObjUser2: String
  otpValObjUser3: String
  otpValObjUser4: String
  otpValObj1: String
  otpValObj2: String
  otpValObj3: String
  otpValObj4: String
  Pass: string
  Pass_user: string

  otpVal_user: String
  type: string = localStorage.getItem('usertype')  // possible values Hospital,Ambulance,Doctor,Lab,Pharmecy,User
  type1: any
  type2: any
  type3: any
  type4: any
  type5: any
  loginData: any = localStorage.getItem('token') ? JSON.parse(localStorage.getItem('logindata')) : {}
  bookingDoctorInfo: any = {
    rating: 0,
    review: 0,
    profilePicture: 'https://digitalmenulist.s3.ap-south-1.amazonaws.com/profilePic_1571915073215.jpeg',
    name: 'Test'

  }
  showEye: boolean = true
  showEyeUser: boolean = true
  showList: boolean = false

  isLoggedIn: boolean = !!localStorage.getItem('token')
  sessionStoreURL = localStorage.getItem('sesssionUrl');

  isListing = false;

  constructor(private auth: AuthService,
    private route: Router, private cd: ChangeDetectorRef,
    private toaster: ToastrService,
    private fireBase: FireBaseMessagingService,
    private router: Router


  ) {
    if (this.sessionStoreURL && this.isLoggedIn) {
      this.route.navigate([`/${this.sessionStoreURL}`])
    }
    $(".token-input-dropdown").css("z-index", "9999")
  }

  ngOnInit() {
    if (this.router.url.includes('/list')) {
      this.isListing = true;
    }
    this.showNotification();
    console.log(this.partner)
    localStorage.removeItem('pharmacyIdBook')
    localStorage.removeItem('pharmacyBookingData')
    console.log(this.route.url)
    this.isLoggedin = this.auth.isLoggedin
    if (this.isLoggedin) {
      this.passwordSet()
    }
    this.getLocation()
    this.fireBaseFunctions();
  }

  getLocation() {
    this.auth.getLocation().then(location => {
      if (!location.nolocation) {
        localStorage.setItem('lat', location.lat)
        localStorage.setItem('lng', location.lng)
      }
      else {
        localStorage.setItem('lat', '30.7333')
        localStorage.setItem('lng', '76.7794')

      }

      if (localStorage.getItem('token')) {
        this.updateProfile();
      }

    })
  }

  passwordSet() {
    let ambulanceBook = localStorage.getItem('ambulanceBook')
    if (!this.loginData.passwordSet && !ambulanceBook) {
      document.getElementById('passwordResetbutton').click()
    }

  }

  EnterOtp(event: NgForm) {
    if (event.submitted && event.valid) {
      this.auth.getOtp(this.phoneNo, this.type, this.countryCode).subscribe((res: any) => {
        console.log(res)
        if (res.statusCode == 200) {
          this.checkOtp = res.data;
          this.loginhide = true
          if (this.checkOtp.passwordSet) {

            this.showpass = true
          }
          else {
            this.showotp = true
            this.errorOtp = false
          }


        } else {
          this.errorOtp = true
          this.errorPass = true

        }
      },
        error => {
          console.log(error)
          this.errorOtp = true
          this.errorPass = true
          this.errorOtpMessage = error.error.message
        }
      )

    }
  }
  EnterOtp_user() {
    if (this.phoneNo_user.length != 10) {
      this.errorOtp_user = true
      this.errorOtpUserMessage = 'Phone Number should be of 10 digits...'
    }
    else {
      this.auth.getOtp(this.phoneNo_user, 'User', this.countryCode_user).subscribe((res: any) => {
        console.log(res)
        if (res.statusCode == 200) {
          // this.showotp_user = true

          this.errorOtp_user = false
          this.checkOtp_user = res.data;

          if (this.checkOtp_user.otp == 1) {
            console.log(this.checkOtp_user.otp)
            this.showpass_user = true
            this.showotp_user_login = true

          }
          else {
            this.showotp_user = true
            this.errorOtp_user = false
            this.showpass_user = false
            this.showotp_user_login = true
          }
        } else {
          this.errorOtp_user = true

        }
      },
        error => {
          this.errorOtpUserMessage = error.error.message
          this.errorOtp_user = true
        }
      )

    }
  }


  setVal(val) {

    this.type = val;
  }

  removeChecked() {

  }
  resendOtpUser() {
    this.auth.getOtp(this.phoneNo_user, 'User', this.countryCode_user).subscribe((res: any) => {
      console.log(res)
      if (res.statusCode == 200) {
        // this.showotp_user = true

        this.errorOtp_user = false
        this.checkOtp_user = res.data;



        this.showotp_user = true
        this.errorOtp_user = false
        this.showpass_user = false
        this.showotp_user_login = true

        this.toaster.success('Otp Sent...', '', {
          timeOut: 2000
        });

      } else {
        //  this.errorOtpUserMessage = "There was some error sending the Otp..."
        this.errorOtp_user = true

      }
    },
      error => {
        this.toaster.error('There was some errro sending the Otp...', '', {
          timeOut: 2000
        });
        this.errorOtpUserMessage = error.error.message
        this.errorOtp_user = true
      }
    )
  }

  resendOtp() {

    this.auth.getOtp(this.phoneNo, this.type, this.countryCode_user).subscribe((res: any) => {
      console.log(res)
      if (res.statusCode == 200) {
        this.showotp = true
        this.errorOtp = false
        this.toaster.success('Otp Sent...', '', {
          timeOut: 2000
        });
        this.checkOtp = res.data;
      } else {
        this.toaster.success('There was some errro sending the Otp...', '', {
          timeOut: 2000
        });
        this.errorOtp = true

      }
    },
      error => {
        this.errorOtp = true
      }
    )


  }

  onCountryChange(event) {
    this.countryCode_user = `+${event.dialCode}`;
  }

  onCountryChangePartner(event) {
    this.countryCode = `+${event.dialCode}`;
  }

  hasError(event) {

  }

  checkOtpfunc() {
    let otp_val = this.otpValObj1 + '' + this.otpValObj2 + '' + this.otpValObj3 + '' + this.otpValObj4
    console.log(otp_val)
    this.auth.checkOtpfunc(this.phoneNo, otp_val, this.type, this.countryCode).subscribe(res => {
      console.log(res)
      if (res == 'Success') {

        this.verifyOtpError = false
        this.showotp = false
        document.getElementById("logintoggle").click();
        let profileUpdated = JSON.parse(localStorage.getItem('logindata'))['profileUpdated']
        localStorage.setItem('sesssionUrl', `/${this.type}/profile-edit`)
        console.log(profileUpdated)
        this.toaster.success('Succesfully logged In...', '', {
          timeOut: 2000
        });
        if (!profileUpdated) {
          this.route.navigate([`/${this.type}/profile-edit`])
        } else {
          if (this.type == 'Blood_bank') {
            this.route.navigate([`/${this.type}/profile-edit`])
          } else {
            this.route.navigate([`/${this.type}/dashboard`])
          }
        }

      }
      // route to profile and result already stored in auth service in localstorage
    }, error => {
      this.verifyOtpError = true
    })
  }
  loginUser() {
    this.phoneNo_user = ''
    this.otpValObjUser1 = ''
    this.otpValObjUser2 = ''
    this.otpValObjUser3 = ''
    this.otpValObjUser4 = ''
    this.showotp_user_login = false
    this.showotp_user = false
    this.showpass_user = false
    this.Pass_user = ''
    this.errorOtpUserMessage = ''
    this.verifyOtpError_user = false
    this.errorOtp_user = false
  }

  forgotPass() {
    this.auth.forgotPass(this.phoneNo, this.type, this.countryCode).subscribe(res => {
      this.toaster.success('Please check your phone for Password...', '', {
        timeOut: 2000
      });
    }, error => {

      this.toaster.error(error.error.message, 'Error', {
        timeOut: 2000
      });
    })
  }

  forgotPassUser() {
    this.auth.forgotPassUser(this.phoneNo_user, this.countryCode_user).subscribe(res => {
      this.toaster.success('Please check your phone for Password...', '', {
        timeOut: 2000
      });
    }, error => {
      this.toaster.success('There was some error sending the password...', '', {
        timeOut: 2000
      });
    })
  }
  checkPassfunc_user() {
    this.auth.checkPassfunc_user(this.phoneNo_user, this.Pass_user, 'User', this.countryCode_user).subscribe(res => {
      console.log(res)
      if (res == 'Success') {
        this.auth.isUserLogin.next(true);
        this.verifyPassError_user = false
        this.showpass_user = false
        document.getElementById("logintoggle_user").click();
        // $(document.body).addClass("modal-open");
        this.loginData = JSON.parse(localStorage.getItem('logindata'))
        //     localStorage.setItem('sesssionUrl', `/${this.type}/profile-edit`)

        this.isLoggedin = true
        this.fireBaseFunctions();

        this.toaster.success('Succesfully logged In...', '', {
          timeOut: 2000
        });

        let labBookingData = JSON.parse(localStorage.getItem('labBookingData'))
        if (labBookingData != null) {
          //  $(document.body).addClass("modal-open");
          console.log('pass login')

          document.getElementById('address_lab').click()
          setTimeout(() => {
            $(document.body).addClass("modal-open");
          }, 1000);


        }

        let pharmacyBookingID = localStorage.getItem('pharmacyIdBook')
        let pharmacyBookingData = JSON.parse(localStorage.getItem('pharmacyBookingData'))
        if (pharmacyBookingID != null) {

          document.getElementById('address_pharmacy').click()

          setTimeout(() => {
            $(document.body).addClass("modal-open");
          }, 1000);
        }
        let doctorBookingData = JSON.parse(localStorage.getItem('doctorBookingData'))
        if (doctorBookingData != null) {
          this.bookingDoctorInfo = JSON.parse(localStorage.getItem('bookingDoctorInfo'))
          //localStorage.removeItem('doctorBookingData')

          document.getElementById('booking_doctor_trigge_doctor').click()


        }
        let hospitalBookingData = JSON.parse(localStorage.getItem('hospitalBookingData'))
        if (hospitalBookingData != null) {
          //  this.bookingDoctorInfo  = JSON.parse(localStorage.getItem('bookingDoctorInfo'))
          // localStorage.removeItem('hospitalBookingData')

          document.getElementById('booking_doctor_trigge_doctor').click()


        }


      }
      // route to profile and result already stored in auth service in localstorage
    }, error => {
      console.log(error)
      this.verifyPassError_user = true
    })
  }
  checkPassfunc() {

    this.auth.checkPassfunc(this.phoneNo, this.Pass, this.type, this.countryCode).subscribe(res => {
      console.log(res)
      if (res == 'Success') {
        this.verifyPassError = false
        this.showpass = false
        document.getElementById("logintoggle").click();
        let profileUpdated = JSON.parse(localStorage.getItem('logindata'))['profileUpdated']
        localStorage.setItem('sesssionUrl', `/${this.type}/profile-edit`)
        console.log(profileUpdated)
        this.toaster.success('Succesfully logged In...', '', {
          timeOut: 2000
        });
        if (!profileUpdated) {
          console.log('profile')
          this.route.navigate([`/${this.type}/profile-edit`])
        } else {
          if (this.type == 'Blood_bank') {
            this.route.navigate([`/${this.type}/profile-edit`])
          } else {
            this.route.navigate([`/${this.type}/dashboard`])
          }
        }

      }
      // route to profile and result already stored in auth service in localstorage
    }, error => {
      console.log(error)
      this.verifyPassError = true
    })
  }

  checkOtpfunc_user() {
    let otp_val = this.otpValObjUser1 + '' + this.otpValObjUser2 + '' + this.otpValObjUser3 + '' + this.otpValObjUser4
    this.auth.checkOtpfunc(this.phoneNo_user, otp_val, 'User').subscribe(res => {
      console.log(res)
      if (res == 'Success') {
        this.auth.isUserLogin.next(true);
        this.verifyOtpError_user = false
        this.showotp_user = false
        this.isLoggedin = true
        this.fireBaseFunctions();
        this.loginData = JSON.parse(localStorage.getItem('logindata'))
        document.getElementById("logintoggle_user").click();

        let doctorBookingData = JSON.parse(localStorage.getItem('doctorBookingData'))
        let hospitalBookingData = JSON.parse(localStorage.getItem('hospitalBookingData'))
        let labBookingData = JSON.parse(localStorage.getItem('labBookingData'))
        let pharmacyBookingID = localStorage.getItem('pharmacyIdBook')
        let pharmacyBookingData = JSON.parse(localStorage.getItem('pharmacyBookingData'))
        let ambulanceBook = localStorage.getItem('ambulanceBook')


        if (!this.loginData.passwordSet) {

          if (doctorBookingData != null) {
            localStorage.removeItem('doctorBookingData')
          }
          else if (hospitalBookingData != null) {
            localStorage.removeItem('hospitalBookingData')
          }
          else if (labBookingData != null) {
            localStorage.removeItem('labBookingData')
          }
          else if (pharmacyBookingID != null) {
            localStorage.removeItem('pharmacyIdBook')
            localStorage.removeItem('pharmacyBookingData')
          }
          else if (ambulanceBook) {
            localStorage.removeItem('ambulanceBook')
          }
          else {
            document.getElementById('passwordResetbutton').click()
          }
        }

        if (labBookingData != null) {
          console.log('otp login')
          // $(document.body).addClass("modal-open");
          // $(document.body).addClass("modal-open");
          document.getElementById('address_lab').click()

          setTimeout(() => {
            $(document.body).addClass("modal-open");
          }, 1000);

        }


        if (pharmacyBookingID != null) {

          document.getElementById('address_pharmacy').click()
          setTimeout(() => {
            $(document.body).addClass("modal-open");
          }, 1000);
        }

        if (doctorBookingData != null) {
          this.bookingDoctorInfo = JSON.parse(localStorage.getItem('bookingDoctorInfo'))
          // localStorage.removeItem('doctorBookingData')

          document.getElementById('booking_doctor_trigge_doctor').click()


        }

        if (hospitalBookingData != null) {
          //  this.bookingDoctorInfo  = JSON.parse(localStorage.getItem('bookingDoctorInfo'))
          // localStorage.removeItem('hospitalBookingData')

          document.getElementById('booking_doctor_trigge_doctor').click()


        }

        //this.route.navigate([`user-profile`])
      }
      // route to profile and result already stored in auth service in localstorage
    }, error => {
      this.verifyOtpError_user = true
    })
  }

  logout() {
    this.auth.logout()
    this.showList = false
    this.isLoggedin = false
    this.route.navigate(['/'])

  }




  numberOnly(event, id): boolean {

    const charCode = (event.which) ? event.which : event.keyCode;

    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    if (id != null) {
      setTimeout(function () { document.getElementById(id).focus() }, 100);

    }
    return true;

  }
  numberOnlyBack(event, id, id1): boolean {

    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode == 37) {
      document.getElementById(id).focus()
      return false
    }
    if (charCode == 39) {
      document.getElementById(id1).focus()
      return false
    }
    if (charCode == 8) {
      event.target.value = ''
      document.getElementById(id).focus()
    }
    // if (id != null)
    //     document.getElementById(id).focus()

    return true;
  }
  counter(i: number) {
    return new Array(i);
  }

  private subscription: Subscription;
  notificationData: any = {};
  showToast = false;

  showNotification() {
    this.subscription = this.auth.notification.subscribe(data => {
      if (data) {
        this.showToast = true;
        this.notificationData = data;
        this.cd.detectChanges();
      }
    });
  }

  hideToast() {
    this.showToast = false;
    if (this.notificationData.type == 'OSP_BY_DOC_TO_USER' || this.notificationData.type == 'OSP_BY_HOS_TO_USER' || this.notificationData.type == 'OSP_BY_LAB_TO_USER'
      || this.notificationData.type == 'OSP_BY_PHCY_TO_USER') {
      this.router.navigate([`/user-orders`]);
    } else if (this.notificationData.type == 'OSP_BY_DOC_TO_USER') {
      this.router.navigate([`/doctors/detail/${this.notificationData.uniqueKey}`]);
    } else if (this.notificationData.type == 'OSP_BY_HOS_TO_USER') {
      this.router.navigate([`/hospitals/detail/${this.notificationData.id}`]);
    } else if (this.notificationData.type == 'OSP_BY_LAB_TO_USER') {
      this.router.navigate([`/labs/detail/${this.notificationData.id}`]);
    } else if (this.notificationData.type == 'OSP_BY_PHCY_TO_USER') {
      this.router.navigate([`/pharmacy/detail/${this.notificationData.id}`]);
    }
    this.notificationData = {};
  }

  fireBaseFunctions() {
    if (localStorage.getItem('token') && localStorage.getItem('usertype') == 'User') {
      this.fireBase.requestPermission();
      this.fireBase.receiveMessage();
    }
  }

  updateProfile() {
    let obj = {
      lat: localStorage.getItem('lat'),
      lng: localStorage.getItem('lng')
    }
    this.auth.profileUpdate('user', obj).subscribe(res => {

    }, error => { })
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
